// extracted by mini-css-extract-plugin
export var bubble = "_3r-0";
export var container = "_3r-3";
export var contrastBorder = "_3r-4";
export var greyOut = "_3r-2";
export var initialsWrapper = "_3r-1";
export var large = "_3r-9";
export var medium = "_3r-8";
export var mediumSmall = "_3r-7";
export var mediumSmallMedium = "_3r-c";
export var micro = "_3r-5";
export var small = "_3r-6";
export var tiny = "_3r-b";
export var xTiny = "_3r-a";